import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ns_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BLOCKED_SITE_MSG = {
  pl: "Nie testujemy stron dla dorosłych ani serwisów z nielegalnymi treściami. Podaj inny adres.",
  en: "We don't test adult websites or sites with illegal content. Please enter a different address.",
  de: "Wir testen keine Erwachsenen-Websites oder Seiten mit illegalen Inhalten. Bitte eine andere Adresse eingeben.",
  es: "No analizamos sitios para adultos ni sitios con contenido ilegal. Introduce otra dirección.",
  fr: "Nous ne testons pas les sites pour adultes ni les sites au contenu illégal. Saisissez une autre adresse.",
  it: "Non testiamo siti per adulti o siti con contenuti illegali. Inserisci un altro indirizzo.",
  pt: "Não testamos sites para adultos nem sites com conteúdo ilegal. Introduza outro endereço.",
  tr: "Yetişkin siteleri veya yasa dışı içerikli siteleri test etmiyoruz. Başka bir adres girin.",
  ru: "Мы не тестируем сайты для взрослых и сайты с нелегальным контентом. Введите другой адрес.",
  ar: "لا نختبر مواقع البالغين أو المواقع ذات المحتوى غير القانوني. أدخل عنوانًا آخر.",
  zh: "我们不检测成人网站或含非法内容的网站。请输入其他地址。",
  ja: "アダルトサイトや違法コンテンツのサイトはテストしません。別のアドレスを入力してください。",
  ko: "성인 사이트나 불법 콘텐츠 사이트는 테스트하지 않습니다. 다른 주소를 입력하세요.",
  hi: "हम वयस्क वेबसाइटों या अवैध सामग्री वाली साइटों का परीक्षण नहीं करते। कृपया दूसरा पता दर्ज करें।",
};
export const isBlockedSite = (detail) => detail === "blocked_site";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Coś poszło nie tak. Spróbuj ponownie.";
  if (isBlockedSite(detail)) {
    const lang = (document.documentElement.lang || "en").slice(0, 2);
    return BLOCKED_SITE_MSG[lang] || BLOCKED_SITE_MSG.en;
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
